module.exports = __webpack_public_path__ + "d06cfa46a599c78225fc0bfc1cff440f.png";